import _ from 'lodash'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { CreateConsultationStepper } from './CreateConsultationStepper'
import { useGetPatientQuery } from '@/core/services/patient'
import { skipToken } from '@reduxjs/toolkit/query'
import { Stack } from '@mui/material'
import HeartbeatLoader from '@/components/ui/loaders/HeartbeatLoader'

type CreateConsultationPageProps = {
  onComplete?: () => void
  startDate?: string
}

export function CreateConsultationPage(props: CreateConsultationPageProps) {
  const { onComplete, startDate: startDateProp } = props

  const [searchParams] = useSearchParams()

  const patientId = searchParams.get('patient') ?? undefined
  const startDate = searchParams.get('startDate') ?? startDateProp
  const speciality = searchParams.get('speciality') ?? undefined

  const { data: patient, isLoading: isFetchingPatient } = useGetPatientQuery(patientId ?? skipToken)

  const initialValues = useMemo(() => ({ patient: patient?._id, speciality, startDate }), [patient, speciality, startDate])

  if (isFetchingPatient) {
    return (
      <Stack flex={1} alignItems="center" justifyContent="center">
        <HeartbeatLoader sx={{ transform: 'scale(4)' }} />
      </Stack>
    )
  }

  return <CreateConsultationStepper initialValues={initialValues} onComplete={onComplete} />
}

export default CreateConsultationPage
